RivalIQ.apps.SocialPosts.module('widgets', function (widgets, App, Backbone, Marionette, $, _) {

    'use strict';

    const Dashboard = RivalIQ.apps.Dashboard;

    const SharedUrls = Dashboard.widgets.SummarizedTableWidget.mixin({
        mixins: {
            linksTableWidgetCsv: App.mixins.LinksTableWidgetCsv
        },
        expansionTracking: RivalIQ.tracking.metric.PostedURLsExpandedTableRow,
        view: App.views.BaseSummarizedTableWidget.extend({
            widgetClassName: 'shared-urls-by-company-table',
            sortAttrPrefix: 'companyIdCanonicalUrl',
            sendMultipleSortCols: true,
            dimensionViewMoreMetricProperty: 'shared_url_count_distinct',
            dimensionViewMoreLinkName: 'View URLs'
        }),
        title: RivalIQ.strings.social_post_shared_urls_title,
        description: RivalIQ.strings.social_post_shared_urls_description,
        viewMorePath: function (overrides) {
            const me = this;
            const props = _.defaults(overrides || {}, {
                limit: -1,
                instanceId: 'shared-urls-by-company'
            }, _.pick(me.getProps(), App.utils.validCurationOptions));
            const route = Dashboard.router.router.resolveCurationRoute(me.curation.id, props);
            return route;
        },
        filter: function () {
            const me = this;
            return !RivalIQ.props.channelAccess(me.getProps());
        },
        getBaseMetric: function () {
            return new RivalIQ.models.MetricDefinition({
                concept: RivalIQ.metrics.descriptions.SOCIAL_POSTS_POSTED_URLS.id,
                dimensions: ['companyId']
            });
        },
        processProps: function (props) {
            const me = this;

            const activityNouns = App.utils.getActivityNouns(props);

            _.defaults(props, {
                domainsOnly: true,
                filter: false,
                showDescriptions: true,
                sortable: true,
                sortOrder: 1,
                metrics: [
                    {
                        name: 'Company',
                        property: 'count', // CompanyLinkFilterCell assumes the property is count
                        sortable: false
                    },
                    {
                        property: 'shared_url_count_distinct'
                    },
                    {
                        name: `Total ${activityNouns.plural}`,
                        property: 'count',
                        description: RivalIQ.str('activity_with_urls_description', activityNouns.plural.toLowerCase())
                    },
                    {
                        property: 'avg_shared_urls'
                    },
                    {
                        property: 'avg_engagement_rate_per_post',
                        description: RivalIQ.str('avg_eng_rate_per_post_with_url_description', activityNouns.plural.toLowerCase())
                    }
                ]
            });

            _.extend(props.metrics[0], {
                cellView: _.constant(RivalIQ.apps.SocialPosts.views.CompanyLinkFilterCell),
                dimensionView: RivalIQ.apps.SocialPosts.widgets.SharedDomainCell
            });

            if (!me.metric) {
                me.metric = me.getBaseMetric();
            }

            App.utils.updateMetric(me.metric, props);

            me.metricsCollection = props.metrics;
            RivalIQ.models.MetricDefinition.build(me, me.metric, {}, 'metricsCollection');

            me.summaryMetrics = me.getSummaryMetrics(props);

            return props;
        },
        getSummaryMetrics: function (props) {
            const metric = RivalIQ.metric.build(props, {
                domainsOnly: true,
                concept: RivalIQ.metrics.descriptions.SOCIAL_POSTS_POSTED_URLS.id,
                dimensions: ['companyId']
            });

            const focusMetric = RivalIQ.metric.build(metric, {
                companyId: props.focusCompanyId
            });

            const landscapeAverageMetric = RivalIQ.metric.build(metric, {
                // NOTE for metrics that define an `aggregate` the `format`
                // property has a special behavior that will cause it to return
                // the export format literal (e.g., `png`) if left in attributes
                format: undefined,
                name: 'Landscape Avg.',
                aggregate: 'average',
                over: ['companyId']
            });

            const activityNouns = App.utils.getActivityNouns(props);
            const audienceName = props.channel === 'facebook' ? 'Page Fan' : 'Follower';

            const metrics = [
                {
                    metrics: [
                        RivalIQ.metric.build(focusMetric, {
                            name: 'Your Unique URLs',
                            description: RivalIQ.strings.your_shared_url_count_distinct_description,
                            property: 'shared_url_count_distinct'
                        }),
                        RivalIQ.metric.build(landscapeAverageMetric, {
                            property: 'shared_url_count_distinct'
                        })
                    ]
                },
                {
                    metrics: [
                        RivalIQ.metric.build(focusMetric, {
                            name: `Your Total ${activityNouns.plural} With URL`,
                            description: RivalIQ.str('your_total_posts_with_url_description', activityNouns.plural.toLowerCase()),
                            property: 'count'
                        }),
                        RivalIQ.metric.build(landscapeAverageMetric, {
                            property: 'count'
                        })
                    ]
                },
                {
                    metrics: [
                        RivalIQ.metric.build(focusMetric, {
                            name: `Your Avg. ${activityNouns.plural} / URL`,
                            description: RivalIQ.str('your_avg_shared_urls_description', activityNouns.plural.toLowerCase()),
                            property: 'avg_shared_urls'
                        }),
                        RivalIQ.metric.build(landscapeAverageMetric, {
                            property: 'avg_shared_urls'
                        })
                    ]
                },
                {
                    metrics: [
                        RivalIQ.metric.build(focusMetric, {
                            name: `Your Eng. Rate by ${audienceName}`,
                            description: RivalIQ.str('your_avg_eng_rate_per_post_with_url_description', activityNouns.plural.toLowerCase(), audienceName.toLowerCase()),
                            property: 'engagement_total / presence_reach'
                        }),
                        {
                            name: 'Landscape Avg.',
                            domainsOnly: true,
                            concept: RivalIQ.metrics.descriptions.SOCIAL_POSTS_POSTED_URLS.id,
                            property: 'engagement_total / presence_reach'
                        }
                    ]
                }
            ];

            return new Backbone.Collection(metrics);
        }
    });

    Marionette.Dashboard.widgets.add(RivalIQ.enums.widgetTypes.SOCIAL_POSTS_SHARED_URLS_BY_COMPANY_TABLE, SharedUrls);

});
